import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePreviousPathname() {
  const location = useLocation();
  const { isOpen } = useTailorIsOpen();
  const [currentPathname, setCurrentPathname] = useState(location.pathname);
  const [previousPathname, setPreviousPathname] = useState('');

  useEffect(() => {
    if (location.pathname !== currentPathname) {
      setPreviousPathname(currentPathname);
      setCurrentPathname(location.pathname);
    }
  }, [location, currentPathname]);

  useEffect(() => {
    if (!isOpen) {
      setPreviousPathname('');
    }
  }, [isOpen]);

  return { currentPathname, previousPathname };
}
